// <TokenLoginAwarder /> — fire-and-forget POST to /api/tokens/event with
// actionKey: 'daily_login'. The proxy server-side computes the per-user
// per-UTC-day dedupeKey, so the client doesn't need to know the format.
//
// The upstream tokens.EarningRule with ActionKey='daily_login' + ContextApp='rprs'
// is what determines whether anything is actually awarded. If that rule isn't
// seeded (or its IsActive=0), this is a harmless no-op.
//
// Mount once at the AppShell level so it runs once per session, not per page.

import { useEffect, useRef } from 'react';
import { useAuth } from '../../auth/AuthContext';

export default function TokenLoginAwarder({ apiBaseUrl, contextApp, ready, optedOut, onAwarded }) {
  const fired = useRef(false);
  const { email } = useAuth();

  useEffect(() => {
    if (!ready || optedOut || fired.current) return;
    // SWA may have masked our principal (~2.73% of requests). Don't fire the
    // award request — the proxy would reject it anyway. We'll get the credit
    // on the next session where the auth is unmasked.
    if (!email || email.includes('*')) return;
    fired.current = true;
    fetch(`${apiBaseUrl}/event`, {
      method:      'POST',
      credentials: 'include',
      headers:     { 'content-type': 'application/json' },
      body:        JSON.stringify({ actionKey: 'daily_login', contextApp }),
    })
      .then(r => {
        // Refresh the badge whether or not anything was actually awarded —
        // upstream returns 200 + { deduped: true } for same-day re-fires; the
        // re-fetch is cheap and keeps the parent in sync if a credit DID land.
        // Caption only renders when balance actually moved, so a deduped fire
        // passes the label silently.
        if (typeof onAwarded === 'function') onAwarded('Daily Reward!');
        return r;
      })
      .catch(() => {
        // intentionally silent — daily-login is a fire-and-forget UX nicety
      });
  }, [ready, optedOut, email, apiBaseUrl, contextApp, onAwarded]);

  return null;
}
